import { useState } from 'react';
import { OpenNewWindow24 } from 'ui/icons';
import { BUTTON_SIZES } from 'ui/button';
import noop from 'utils/noop';
import {
  ARROW_DIRECTION_DOWN,
  CollapsibleContent,
  CollapsibleContentArrow,
} from 'ui/collapsibleContent';
import {
  ActionButton,
  ConnectLink,
  AccountDetails,
  Wrapper,
  Main,
  AccountName,
  RightContent,
  SectionHeading,
  ArrowButton,
} from '../AccountsSection.styled';
import { EmailChannelRow } from './EmailChannelRow';
import { useSendingPlatformsQueryContext } from '../../../contexts';
import { DEFAULT_SENDER_TEXT, SES_ACCOUNT_NAME } from '../../../constants';

export const TEXT = {
  CONNECT_BUTTON: 'Connect to channels',
};

export const SESAccountSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { selectSESChannels, isSESDefault } = useSendingPlatformsQueryContext();

  const channels = selectSESChannels();
  const channelTerm = 'connected channel';
  const collapseBtnText =
    channels.length === 1 ? `1 ${channelTerm}` : `${channels.length} ${channelTerm}s`;

  return (
    <Wrapper data-test="email-account-iterable">
      <Main>
        <div>
          <AccountName>{SES_ACCOUNT_NAME}</AccountName>
          {isSESDefault() && <AccountDetails>{DEFAULT_SENDER_TEXT}</AccountDetails>}
        </div>
        <RightContent>
          {channels.length > 0 ? (
            <ArrowButton onClick={() => setIsExpanded(!isExpanded)} size={BUTTON_SIZES.SMALL}>
              <span>{collapseBtnText}</span>
              <CollapsibleContentArrow
                isCollapsed={!isExpanded}
                arrowStart={ARROW_DIRECTION_DOWN}
                arrowEnd={180}
                width={16}
                height={16}
              />
            </ArrowButton>
          ) : (
            <ConnectLink href="/settings/channels" target="_blank">
              <ActionButton size={BUTTON_SIZES.LARGE} onClick={noop}>
                <span>{TEXT.CONNECT_BUTTON}</span>
                <OpenNewWindow24 />
              </ActionButton>
            </ConnectLink>
          )}
        </RightContent>
      </Main>
      {channels.length > 0 && (
        <CollapsibleContent isCollapsed={!isExpanded}>
          <SectionHeading>{`${channelTerm}s`}</SectionHeading>
          {channels.map((channel) => (
            <EmailChannelRow key={channel.id} channel={channel} />
          ))}
        </CollapsibleContent>
      )}
    </Wrapper>
  );
};
